export default "__VITE_ASSET__Du4QLrVV__"